import {createReducer} from 'typesafe-actions';
import {
  GetEditangleAction,
  GetEditangleState,
} from 'modules/getEditangle/types';
import {getEditangleAction} from 'modules/getEditangle/actions';
import {
  asyncState,
  createAsyncReducer,
  transformToArray,
} from 'lib/reducerUtils';

const initialState: GetEditangleState = {
  data: asyncState.initial(),
};

const getEditangle = createReducer<GetEditangleState, GetEditangleAction>(
  initialState,
).handleAction(
  transformToArray(getEditangleAction),
  createAsyncReducer(getEditangleAction, 'data'),
);

export default getEditangle;
